import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import useAuth from "../../hooks/useAuth";
import AuditModal from "./AuditModal";
import AuditContext from "./context/AuditProvider";
import JoditEditor from "jodit-react";
import "./GeneralParamsStyle.css";
const baseURL = process.env.REACT_APP_API_JOBS;

const GeneralParams = ({ handleCancelClick }) => {
  const { showAudit, setShowAudit, model, setModel, srcId, setSrcId } =
    useContext(AuditContext);
  const [genParams, setGenParams] = useState([]);
  const [sysLangOptions, setSysLangOptions] = useState();
  const [proposalStatusOptions, setProposalStatusOptions] = useState();
  const axiosPrivate = useAxiosPrivate("application/json");
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const editor1 = useRef(null);
  const editor2 = useRef(null);
  const submitButton = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    [],
  );

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getDataSysLangOptions = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "syslangtype/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setSysLangOptions(response.data[0].sysLangOptions);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    const getProposalStatusOptions = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "proposalstatus/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setProposalStatusOptions(response.data[0].proposalStatusOptions);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "genparams/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setGenParams(response.data[0]);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getDataSysLangOptions();
    getProposalStatusOptions();
    getData();
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    if (name === "rosh_hotem") {
      genParams.rosh_hotem = e.target.checked;
    } else {
      setGenParams((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit");
    let isMounted = true;
    const controller = new AbortController();
    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "genparams/" + genParams.id + "/",
          genParams,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          alert("עודכן בהצלחה");
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    updateData();
  };

  return (
    <>
      <div className="ap-root">
        {/* Audit modal rendered outside layout flow */}
        {showAudit && <AuditModal />}

        {/* ── Top navigation bar ── */}
        <nav className="ap-topbar">
          <span className="ap-topbar-title">ניהול משתמשים</span>

          <button
            className="ap-audit-btn"
            onClick={() => {
              setModel("GenPar");
              setSrcId(1);
              setShowAudit(true);
            }}
          >
            תיעוד שינויי רמת הסודיות
          </button>

          <button
            className="ap-nav-btn"
            onClick={() => navigate("/getloginlog")}
          >
            תיעוד התחברות למערכת
          </button>
          <button className="ap-nav-btn" onClick={() => navigate("/users")}>
            ניהול משתמשים
          </button>
          {/* 
          <button
            className="ap-nav-btn"
            onClick={() => navigate("/getloggedinusers")}
          >
            משתמשים מקוונים
          </button>
          */}

          {auth?.roles?.includes("SuperAdmin") && (
            <div className="ap-super-group">
              <span className="ap-super-label">SuperAdmin</span>
              <button
                className="ap-nav-btn"
                onClick={() => navigate("/exportusers")}
              >
                יצוא משתמשים
              </button>
              <button
                className="ap-nav-btn"
                onClick={() => navigate("/exportmekhrazeem")}
              >
                יצוא מכרזים
              </button>
              <button
                className="ap-nav-btn"
                onClick={() => navigate("/exportmoamadeem")}
              >
                יצוא מועמדויות
              </button>
            </div>
          )}
        </nav>

        {/* ── Page body ── */}
        <div className="ap-body">
          <div className="ap-page-header">
            <h1>עדכון פרמטרים</h1>
            <p>הגדרות מערכת כלליות ותצורת מכרזים</p>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Card 1 — General settings */}
            <div
              className="ap-cards-row"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "1rem",
              }}
            >
              <div className="ap-card">
                <div className="ap-card-title">הגדרות כלליות</div>

                {/* Language */}
                <div className="ap-field">
                  <label htmlFor="system_lang" className="ap-label">
                    שפת ההתכתבויות
                  </label>
                  <select
                    id="system_lang"
                    name="system_lang"
                    className="ap-select"
                    onChange={handleChange}
                    value={genParams.system_lang}
                  >
                    <option value="">בחר שפה</option>
                    {sysLangOptions?.map((a) => (
                      <option key={a[0]} value={a[1]}>
                        {a[1]}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Confidentiality */}
                <div className="ap-field">
                  <label htmlFor="proposal_status" className="ap-label">
                    סודיות הצעת המועמד
                    <span className="ap-sublabel">— SuperAdmin בלבד</span>
                  </label>
                  <select
                    id="proposal_status"
                    name="proposal_status"
                    className="ap-select"
                    disabled={!auth?.roles?.includes("SuperAdmin")}
                    onChange={handleChange}
                    value={genParams.proposal_status}
                  >
                    <option value="">בחר רמת סודיות</option>
                    {proposalStatusOptions?.map((a) => (
                      <option key={a[0]} value={a[1]}>
                        {a[1]}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Mayor signer checkbox */}
                <div className="ap-field">
                  <label className="ap-checkbox-row" htmlFor="rosh_hotem">
                    <input
                      type="checkbox"
                      id="rosh_hotem"
                      name="rosh_hotem"
                      defaultChecked={genParams.rosh_hotem}
                      onChange={handleChange}
                    />
                    <span className="ap-checkbox-label">
                      ראש העיר הוא החותם על ההתכתבויות
                    </span>
                  </label>
                </div>
              </div>

              {/* Block 2 - הבלוק החדש */}
              <div className="ap-card">
                <div className="ap-card-title">
                  כתובות מייל להתראה במקרה של ריבוי כניסות לא מוצלחות
                </div>

                <div className="ap-field">
                  <label htmlFor="email1_for_faild_alert" className="ap-label">
                    כתובת מייל ראשונה -חובה-
                  </label>
                  <input
                    type="email"
                    name="email1_for_faild_alert"
                    id="email1_for_faild_alert"
                    required
                    placeholder="aaa@example.com"
                    value={genParams.email1_for_faild_alert}
                    onChange={handleChange}
                  />
                  <label htmlFor="email2_for_faild_alert" className="ap-label">
                    כתובת מייל שניה
                  </label>
                  <input
                    type="email"
                    name="email2_for_faild_alert"
                    id="email2_for_faild_alert"
                    placeholder="aaa@example.com"
                    value={genParams.email2_for_faild_alert}
                    onChange={handleChange}
                  />
                  <label htmlFor="email3_for_faild_alert" className="ap-label">
                    כתובת מייל נוספת
                  </label>
                  <input
                    type="email"
                    name="email3_for_faild_alert"
                    id="email3_for_faild_alert"
                    placeholder="aaa@example.com"
                    value={genParams.email3_for_faild_alert}
                    onChange={handleChange}
                  />
                  <label htmlFor="max_num_faild_alert" className="ap-label">
                    מספר הכישלונות הרצופים לשליחת התראה:
                  </label>
                  <input
                    type="number"
                    name="max_num_faild_alert"
                    value={genParams.max_num_faild_alert}
                    onChange={handleChange}
                    className="form-control"
                    id="max_num_faild_alert"
                    placeholder="1"
                    min="1"
                    step="1"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Card 2 — Prefix paragraph */}
            <div className="ap-card">
              <div className="ap-card-title">תוכן מכרז — רישא</div>
              <div className="ap-field">
                <label htmlFor="mkh_prefix" className="ap-editor-label">
                  פיסקה מקדימה אחרי כותרת המכרז
                </label>
                <JoditEditor
                  ref={editor1}
                  tabIndex={20}
                  name="mkh_prefix"
                  value={genParams?.mkh_prefix}
                  config={config}
                  onBlur={(newContent) =>
                    setGenParams((prev) => ({
                      ...prev,
                      mkh_prefix: newContent,
                    }))
                  }
                />
              </div>
            </div>

            {/* Card 3 — Suffix paragraph */}
            <div className="ap-card">
              <div className="ap-card-title">תוכן מכרז — סיפא</div>
              <div className="ap-field">
                <label htmlFor="mkh_suffix" className="ap-editor-label">
                  פיסקה לפני החתימה על פרסום המכרז
                </label>
                <JoditEditor
                  ref={editor2}
                  tabIndex={21}
                  name="mkh_suffix"
                  value={genParams?.mkh_suffix}
                  config={config}
                  onBlur={(newContent) =>
                    setGenParams((prev) => ({
                      ...prev,
                      mkh_suffix: newContent,
                    }))
                  }
                />
              </div>
            </div>

            {/* Submit */}
            <div className="ap-submit-bar">
              <button
                type="submit"
                ref={submitButton}
                tabIndex={23}
                className="ap-submit-btn"
              >
                שמור שינויים
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default GeneralParams;
